import { isManagerOrAbove } from './permissions';

/**
 * Get the FA icon class for a given job state.
 * Returns just the class string so callers can render however they like.
 */
export const getStateIcon = (state, userType) => {
  if (state === 'new' && userType === 'installer') return 'fa-sharp fa-solid fa-credit-card';
  switch (state) {
    case 'new':       return 'fa-sharp fa-solid fa-comment';
    case 'answered':  return 'fa-sharp fa-solid fa-bell';
    case 'scheduled': return 'fa-sharp fa-solid fa-calendar';
    case 'received':  return 'fa-sharp fa-solid fa-battery-empty';
    case 'started':   return 'fa-sharp fa-solid fa-battery-half';
    case 'finished':
      return userType === 'dealer' ? 'fa-sharp fa-solid fa-car' : 'fa-sharp fa-solid fa-dollar-sign';
    case 'paid':      return 'fa-sharp fa-solid fa-car';
    case 'collected': return 'fa-sharp fa-regular fa-star';
    default:          return '';
  }
};

export const canTransferJob = (request, currentInstaller, userRole) => {
  // Transfer is available for admin, owner, manager in early states (before work has started)
  const transferableStates = ['new', 'estimated', 'accepted', 'scheduled'];
  return (
    isManagerOrAbove(userRole) &&
    transferableStates.includes(request.currentState) &&
    request.assignedTo === currentInstaller.installer_id
  );
};